<template>
<div>
  <div class="col-12" v-if="uid">
                    
    <div class="menu-item px-3">
      <div class="menu-content d-flex align-items-center px-3">
        <div class="symbol symbol-50px me-5">
          <img
            v-if="sigla"
            alt="LogoFirma"
            :src="'/api/fisiere/sigla-firma/' + firma_id"
            @error="sigla = false"
            style="object-fit: cover; width: 50px; height: 50px;"
          />
          <div
            v-else
            class="symbol-label fs-3 bg-light-warning text-warning"
          >
            {{ $filters.initialeFirma(denumire_firma) }}
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="fw-bold d-flex align-items-center fs-5">
            <span class="badge badge-dark fw-bold fs-8 px-2 py-1 ms-2" v-if="$gate.isWebDev()">{{ $t("cont.tip_cont.webdev") }}</span>
            <span class="badge badge-warning fw-bold fs-8 px-2 py-1 ms-2" v-if="$gate.isAdmin()">{{ $t("cont.tip_cont.administrator") }}</span>
            <span class="badge badge-info fw-bold fs-8 px-2 py-1 ms-2" v-if="$gate.isGalerie()">{{ $t("cont.tip_cont.galerie") }}</span>
            <span class="badge badge-primary fw-bold fs-8 px-2 py-1 ms-2" v-if="$gate.isArtist()">{{ $t("cont.tip_cont.artist") }}</span>
            <span class="badge badge-success fw-bold fs-8 px-2 py-1 ms-2" v-if="$gate.isClient()">{{ $t("cont.tip_cont.client") }}</span>
          </div>
          <div class="separator my-2"></div>
          <div class="fw-bold d-flex align-items-center fs-5">
            {{ denumire_firma }} 
          </div>
          <div class="fw-bold d-flex align-items-center fs-5">
            <span
              v-if="badgeRolFirma" :class="'badge fw-bold fs-8 px-2 py-1 ms-2 ' + badgeRolFirma.class">
              {{ badgeRolFirma.text }}
            </span>
          </div>
          <div class="separator my-2"></div>
          <a class="fw-bold text-muted text-hover-primary fs-7">{{ nume }} {{ prenume }}</a>
          <a class="fw-bold text-muted text-hover-primary fs-7">{{ email }}</a>
        </div>
      </div>
    </div>

    <!-- SECTIUNE EXCLUSIV MOBIL: Detalii Firma Curenta, Schimba Firma & Ghid Interactiv -->
    <div class="d-md-none px-5 py-2">
      <div class="p-3 bg-light rounded border mb-3">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="badge badge-success fw-bold fs-9 text-uppercase">
            <i class="fa-solid fa-building text-white me-1 fs-9"></i> Firma Mea
          </span>
          <button
            v-if="hasMultipleFirme"
            type="button"
            class="btn btn-xs btn-primary fw-bold px-2 py-1 d-flex align-items-center gap-1"
            @click="openModalSchimbaFirme"
          >
            <i class="fa-solid fa-arrows-rotate fs-8"></i>
            <span>Schimbă</span>
          </button>
        </div>
        <div class="fw-bold fs-6 text-dark text-break lh-sm" :title="denumire_firma" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
          {{ denumire_firma || 'Fără firmă selectată' }}
        </div>
        <div class="text-muted fs-8 mt-1" v-if="cui_firma">
          CUI: <span class="fw-semibold text-dark">{{ cui_firma }}</span>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-sm btn-light-primary w-100 d-flex align-items-center justify-content-center gap-2 py-2 mb-2"
        @click="openHelp"
      >
        <i class="fa-solid fa-circle-question fs-5 text-primary"></i>
        <span class="fw-bold fs-7">Ghid & Asistență</span>
      </button>
    </div>

    <div class="separator my-2"></div>
    
    <div class="menu-item px-5">
      <router-link to="/contul-meu" class="menu-link px-5">{{ $t("meniu.profilul_meu") }}</router-link>
    </div>
  </div>
    <div class="separator my-2"></div>
    <div ref="themeMenuItem" class="menu-item px-5" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="left-start" data-kt-menu-offset="-15px, 0">
      <a href="#" class="menu-link px-5">
        <span class="menu-title position-relative">{{ $t("meniu.mod_tema") }}
        <span class="ms-5 position-absolute translate-middle-y top-50 end-0">
          <i class="ki-duotone ki-night-day theme-light-show fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
            <span class="path6"></span>
            <span class="path7"></span>
            <span class="path8"></span>
            <span class="path9"></span>
            <span class="path10"></span>
          </i>
          <i class="ki-duotone ki-moon theme-dark-show fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </span></span>
      </a>
      <div ref="themeMenu" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px" data-kt-menu="true" data-kt-element="theme-mode-menu">
        <div class="menu-item px-3 my-0">
          <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="light" @click.prevent="onThemeClick($event)">
            <span class="menu-icon" data-kt-element="icon">
              <i class="ki-duotone ki-night-day fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
                <span class="path6"></span>
                <span class="path7"></span>
                <span class="path8"></span>
                <span class="path9"></span>
                <span class="path10"></span>
              </i>
            </span>
            <span class="menu-title">{{ $t("meniu.culoare_tema.deschisa") }}</span>
          </a>
        </div>
        <div class="menu-item px-3 my-0">
          <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="dark" @click.prevent="onThemeClick($event)">
            <span class="menu-icon" data-kt-element="icon">
              <i class="ki-duotone ki-moon fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </span>
            <span class="menu-title">{{ $t("meniu.culoare_tema.inchisa") }}</span>
          </a>
        </div>
        <div class="menu-item px-3 my-0">
          <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="system" @click.prevent="onThemeClick($event)">
            <span class="menu-icon" data-kt-element="icon">
              <i class="ki-duotone ki-screen fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
              </i>
            </span>
            <span class="menu-title">{{ $t("meniu.culoare_tema.system") }}</span>
          </a>
        </div>
      </div>
    </div>
    
  
</div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    uid: {
      type: [Number, String],
      default: null,
    },
  },
  //name: 'SwitchLocale',
  data () {
    
    return { 
      langs: ['Romana', 'English'],
      langs_flags: ['/assets/media/flags/romania.svg', '/assets/media/flags/united-states.svg'],
      lang_id: localStorage.language_id,
      nume:'',
      prenume: '',
      email: '',
      tip_cont: '',
      firma_id: '',
      rol_firma: '',
      denumire_firma: '',
      cui_firma: '',
      siglaGasita: true,
      sigla: false,
    }
  },

  methods:{
    openModalSchimbaFirme() {
      window.dispatchEvent(new Event('open-modal-schimba-firme'));
    },
    openHelp() {
      if (typeof window.openHelpModal === 'function') {
        window.openHelpModal();
      }
    },
    // Handle click on theme entries
    onThemeClick(e) {
      const el = e.currentTarget
      const mode = el?.getAttribute('data-kt-value') || 'light'
      this.applyTheme(mode)
      // close submenu (KTMenu or fallback)
      this.closeThemeMenu()
    },

    // Apply theme (light/dark/system) and persist
    applyTheme(mode) {
      const resolve = (m) => {
        if (m === 'system') {
          return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
        }
        return (m === 'dark') ? 'dark' : 'light'
      }
      const resolved = resolve(mode)
      try { localStorage.setItem('kt_theme_mode', mode) } catch {}
      // set attributes used by Bootstrap 5.3+ / themes
      const root = document.documentElement
      root.setAttribute('data-bs-theme', resolved)
      root.setAttribute('data-theme', resolved)
      // optional body class toggle (helps some themes)
      document.body.classList.toggle('dark-mode', resolved === 'dark')
    },

    // Try to initialize with KTMenu; if missing, bind a minimal fallback
    initThemeMenu() {
      const wrap = this.$refs.themeMenuItem
      const menuEl = this.$refs.themeMenu
      if (!wrap || !menuEl) return
      try {
        if (window.KTMenu) {
          let inst = (typeof window.KTMenu.getInstance === 'function') ? window.KTMenu.getInstance(menuEl) : null
          if (!inst) {
            if (typeof window.KTMenu === 'function') {
              inst = new window.KTMenu(menuEl)
            } else if (typeof window.KTMenu.createInstances === 'function') {
              window.KTMenu.createInstances()
              inst = (typeof window.KTMenu.getInstance === 'function') ? window.KTMenu.getInstance(menuEl) : null
            }
          }
          if (inst) return // done
        }
      } catch (_) {}
      // Fallback if KTMenu inert
      this.bindThemeMenuFallback()
    },

    bindThemeMenuFallback() {
      const wrap = this.$refs.themeMenuItem
      const menuEl = this.$refs.themeMenu
      if (!wrap || !menuEl) return
      const trigger = wrap.querySelector('[data-kt-menu-trigger]') || wrap.querySelector('.menu-link')
      if (!trigger) return

      wrap.style.position = wrap.style.position || 'relative'
      menuEl.style.position = 'absolute'
      const place = () => {
        const rect = trigger.getBoundingClientRect()
        const wRect = wrap.getBoundingClientRect()
        const top = rect.bottom - wRect.top + 6
        menuEl.style.top = top + 'px'
        // left-start => open to the left of the parent dropdown
        const offsetX = 15
        menuEl.style.right = ((wrap.clientWidth || 0) + offsetX) + 'px'
        menuEl.style.left = 'auto'
        menuEl.style.zIndex = '1051'
      }
      const show = () => { place(); menuEl.classList.add('show'); menuEl.style.display = 'block'; document.addEventListener('click', onDoc, { once: true }) }
      const hide = () => { menuEl.classList.remove('show'); menuEl.style.display = 'none' }
      const toggle = (e) => { e && e.preventDefault(); (menuEl.classList.contains('show') ? hide() : show()) }
      const onDoc = (e) => { if (!wrap.contains(e.target)) hide() }

      // replace existing listeners by cloning trigger
      const newTrig = trigger.cloneNode(true)
      trigger.parentNode.replaceChild(newTrig, trigger)

      const mq = window.matchMedia('(min-width: 992px)')
      const bind = () => {
        if (mq.matches) {
          newTrig.addEventListener('mouseenter', show)
          wrap.addEventListener('mouseleave', hide)
        } else {
          newTrig.addEventListener('click', toggle)
        }
      }
      bind()
      mq.addEventListener && mq.addEventListener('change', () => { hide(); bind() })

      // expose close helper
      this.closeThemeMenu = hide
    },

    closeThemeMenu() {
      // no-op; replaced when fallback binds
    },

    ChangeLang(lang, lang_id){
      localStorage.setItem('language', lang);
      localStorage.setItem('language_id', lang_id);
      this.lang_id = lang_id;
      this.$i18n.locale = lang;
      //this.$i18n.locale = lang;
    },
    incarcaCont(id){
      const numId = Number(id)
      if (!numId) return

      axios.get('/api/module/cont/' + numId)
        .then((response)=>{
          const d = response?.data || {}

          // Prefer the old flat shape first
          const nume = d.nume ?? d.user?.nume ?? ''
          const prenume = d.prenume ?? d.user?.prenume ?? ''
          const email = d.email ?? d.user?.email ?? ''
          const tip_cont = (d.tip_cont ?? d.user?.tip_cont)

          const firma = (
            d.firma_curenta || d.user?.firma_curenta || {}
          )
          const firma_id = (d.id_firma_autentificata ?? firma.id ?? '')
          const denumire_firma = (d.denumire_firma ?? firma.denumire ?? '')
          const cui_firma = (firma.cui ?? '')

          // rol_firma / sigla – păstrează compatibilitate
          const rol_firma = (d.rol_firma ?? this.rol_firma ?? null)
          const sigla = (typeof d.sigla !== 'undefined') ? !!d.sigla : !!firma_id

          // set state
          this.nume = nume
          this.prenume = prenume
          this.email = email
          this.tip_cont = tip_cont ?? ''
          this.firma_id = firma_id
          this.denumire_firma = denumire_firma
          this.cui_firma = cui_firma
          this.rol_firma = rol_firma
          this.sigla = sigla
        })
        .catch((e)=>{
          console.warn('incarcaCont error:', e)
        })
    },


  },

  mounted() {
    if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang;
    // Apply saved theme on mount
    try {
      const saved = localStorage.getItem('kt_theme_mode') || 'system'
      this.applyTheme(saved)
    } catch { this.applyTheme('system') }
    // Initialize theme submenu (KTMenu or fallback)
    this.$nextTick(() => this.initThemeMenu())
    if (window.emitter) {
      window.emitter.on('firma-schimbata', () => this.incarcaCont(this.uid))
    }
  },
  beforeUnmount() {
    if (window.emitter) {
      window.emitter.off('firma-schimbata', () => this.incarcaCont(this.uid))
    }
  },
  
  created(){
    //if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang;
    this.incarcaCont(this.uid);
  },

  computed: {
    badgeRolFirma() {
      const map = {
        1: { text: 'Vizualizare', class: 'badge-success' },
        2: { text: 'Contabilitate', class: 'badge-primary' },
        3: { text: 'Editare', class: 'badge-info' },
        4: { text: 'Administrare', class: 'badge-warning' },
        5: { text: 'Detinator', class: 'badge-danger' },
      };
      return map[this.rol_firma] ?? null;
    },
    hasMultipleFirme() {
      if (typeof window.initialUserData?.has_multiple_firme === 'boolean') {
        return window.initialUserData.has_multiple_firme;
      }
      return true;
    }
  }

}
</script>